/**
 * Shown next to the HTML source of a mail that has section edits, once
 * the source differs from what is stored: saving it makes this HTML the
 * new original and empties the section edit model.
 */
export function SectionEditsNotice() {
  return (
    <p
      role="note"
      className="m-0 rounded-xl border border-warning-marker/40 bg-warning-bg px-4 py-3 text-sm text-warning-text"
    >
      <strong className="font-semibold">Section edits are now part of the HTML.</strong> This mail
      was changed in the section editor. When you save this HTML, it becomes the new starting point:
      the changes made there stay as they are written here, “Reset to original” goes back to this
      HTML, and sections that were hidden or removed there cannot be brought back.
    </p>
  );
}
